export default __webpack_public_path__ + "static/media/goopter-movie-theatre-order-automation-process.f963139e.png";